angular
	.module 'App.Component'
	.component 'skuInput',
		{
			templateUrl: '@component/input/sku-input/sku-input.view.html'
			controller: 'SkuInputController'
			controllerAs: 'input'
			require:
				ngModelController: 'ngModel'
			bindings:
				id: '<?'
				isDisabled: '<?'
				isRequired: '<?'
				ngModel: '='
				ngModelOptions: '<?'
				duplicateSkuInfo: '<?'
				numberOfDuplicatesShown: '<?'
				tooltipTemplate: '@?'
				onChangeCallback: '&?'
				isActionDisabled: '<?'
				actionButtonClasses: '<?'
				actionButtonIcon: '<?'
				actionCallback: '&?'
		}

class SkuInputController extends AbstractController
	@register()
	@inject 'parseBool',
		'translate',
		'$timeout'

	initialize: ->
		@id ?= "sku-#{@controllerId}"
		@isDisabled ?= false
		@isDisabled = @parseBool(@isDisabled)
		@isRequired ?= false
		@isRequired = @parseBool(@isRequired)
		@isActionDisabled ?= false
		@isActionDisabled = @parseBool(@isActionDisabled)
		@numberOfDuplicatesShown ?= 5
		@ngModelOptions = angular.extend({debounce: 500}, @ngModelOptions)

	hasAction: ->
		return @actionCallback?

	hasDuplicates: ->
		return @duplicateSkuInfo? && !_.isEmpty(@duplicateSkuInfo)

	getDuplicatesForListing: ->
		return (@duplicateSkuInfo ? []).slice(0, @numberOfDuplicatesShown)

	getUnlistedDuplicatesCount: ->
		length = (@duplicateSkuInfo ? []).length
		return length - Math.min(length, @numberOfDuplicatesShown)

	isUnlistedDuplicatesCountSingleDigit: ->
		count = @getUnlistedDuplicatesCount()

		return count > 0 && count <= 9

	isUnlistedDuplicatesCountMultiDigit: ->
		return @getUnlistedDuplicatesCount() > 9

	onChange: ->
		# Using timout to allow Angular to "catch up" with ngModel change, otherwise callback will be called
		# before ngModel value change apply (same as DropdownComponent.coffee)
		@$timeout => @onChangeCallback()
